import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import { addContributor, removeContributor } from '../../../../../store/slices/bookSlice';

const ContributorsSection: React.FC = () => {
  const dispatch = useAppDispatch();
  const bookData = useAppSelector((state) => state.book.bookData);
  const [newContributor, setNewContributor] = useState('');
  const [contributorType, setContributorType] = useState('Select Type');

  const handleAdd = () => {
    if (newContributor && contributorType !== 'Select Type') {
      dispatch(addContributor({ name: newContributor, type: contributorType }));
      setNewContributor('');
      setContributorType('Select Type');
    }
  };

  return (
    <div>
      <label className="block text-gray-900 text-sm font-medium mb-2">Add Contributors</label>
      <div className="flex flex-col md:flex-row gap-2">
        <input
          type="text"
          value={newContributor}
          onChange={(e) => setNewContributor(e.target.value)}
          className="flex-1 bg-gray-50 text-gray-900 px-3 py-2.5 rounded-md border border-gray-300 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:bg-white"
          placeholder="Enter here"
        />
        <div className="flex gap-2">
          <select
            value={contributorType}
            onChange={(e) => setContributorType(e.target.value)}
            className="flex-1 md:flex-none bg-gray-50 text-gray-900 px-3 py-2.5 pr-8 md:pr-3 rounded-md border border-gray-300 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 focus:bg-white"
          >
            <option>Select type</option>
            <option>Editor</option>
            <option>Illustrator</option>
            <option>Translator</option>
            <option>Co-Author</option>
          </select>
          <button onClick={handleAdd} className="bg-gray-900 text-white px-6 md:px-5 py-2.5 rounded-md hover:bg-gray-800 font-medium">Add</button>
        </div>
      </div>

      {bookData.contributors.length > 0 && (
        <div className="mt-3 space-y-2">
          {bookData.contributors.map((contributor, index) => (
            <div key={index} className="flex justify-between items-center bg-gray-200 md:bg-gray-700 px-3 py-2 rounded">
              <span className="text-gray-900 md:text-white text-sm">{contributor.name} - {contributor.type}</span>
              <button onClick={() => dispatch(removeContributor(index))} className="text-red-600 md:text-red-400 hover:text-red-700 text-sm">Remove</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContributorsSection;
